<template lang="pug">
  .logo(:class="{'show': logoShow}")
    //img.kids(src="~assets/ui/logo/logo-kids.png")
    img.kids(v-if="modeSwitchable && mode === MODES.KIDS" src="~assets/ui/logo/logo-kids.png")
    img.adults(v-if="!modeSwitchable || mode === MODES.ADULTS" src="~assets/ui/logo/logo-adults.png")

</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3} from 'gsap'
import * as MODES from 'src/config/modes'

export default {
  name: "Logo",
  props: {
    modeSwitchable: {
      default: true
    }
  },
  components: {},
  data() {
    return {
      MODES,
      logoShow: false
    }
  },
  computed:{
    ...mapState('app', ['mode']),
  },
  methods: {

    init() {

    },
    animate() {},
    showLogo(){
      this.logoShow = true
    }
  },
  mounted() {
    window.Logo = this
    this.init()
    this.animate()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .logo
    //background: greenyellow
    line-height: 0
    position: relative
    top: $ui-margin-top - 0.35rem


    margin: 0 auto
    // z-index: 10
    width: 2.1rem
    text-align: center
    pointer-events: none
    //background: #3a54a2
    transform: translate3d(0, -300%, 0)
    transition-property: transform
    transition-duration: 0.7s
    transition-delay: 1s
    transition-timing-function: ease-out
    &.show
      transform: translate3d(0, 0, 0)


    img
      //background: #ffd81b
      display: inline-block
      height: $ui-margin-top*0.5
      //margin-left: -0.1rem

    .kids






</style>